import { OPERATOR_CONTEXT_MENU_SERVICE_NAME, OperatorContextMenuServiceProvider } from './operator.context-menu.service'
import { OPERATOR_CREATE_EDIT_SERVICE_NAME, OperatorCreateEditServiceProvider } from './operator.create-edit.service'
import { OPERATOR_DEPOSITORY_SERVICE_NAME, OperatorDepositoryServiceProvider } from './operator.depository.service'
import { OPERATOR_NOTIFICATIONS_SERVICE_NAME, OperatorNotificationserviceProvider } from './operator.notifications.service'
import { OPERATOR_SECURITY_SERVICE_NAME, OperatorSecurityServiceProvider } from './operator.security.service'
import { OPERATOR_SERVICE_NAME, OperatorServiceProvider } from './operator.service'
import { OPERATOR_SETTINGS_SERVICE_NAME, OperatorSettingsServiceProvider } from './operator.settings.service'
import { OPERATOR_TECHNICAL_PERMISSIONS_SERVICE_NAME, OperatorTechnicalPermissionsServiceProvider } from './operator.technical-permissions.service'

export const OPERATOR_SERVICES_MODULE_NAME = 'simax.services.operator'

const module = angular.module(OPERATOR_SERVICES_MODULE_NAME, [])

module.provider(OPERATOR_CONTEXT_MENU_SERVICE_NAME, OperatorContextMenuServiceProvider)
module.provider(OPERATOR_CREATE_EDIT_SERVICE_NAME, OperatorCreateEditServiceProvider)
module.provider(OPERATOR_DEPOSITORY_SERVICE_NAME, OperatorDepositoryServiceProvider)
module.provider(OPERATOR_NOTIFICATIONS_SERVICE_NAME, OperatorNotificationserviceProvider)
module.provider(OPERATOR_SECURITY_SERVICE_NAME, OperatorSecurityServiceProvider)
module.provider(OPERATOR_SERVICE_NAME, OperatorServiceProvider)
module.provider(OPERATOR_SETTINGS_SERVICE_NAME, OperatorSettingsServiceProvider)
module.provider(OPERATOR_TECHNICAL_PERMISSIONS_SERVICE_NAME, OperatorTechnicalPermissionsServiceProvider)
